import { Component, Input, Type } from '@angular/core';
import { takeUntil } from 'rxjs';
import { OrganizationPersonsEditComponent } from 'src/app/routes/directory/directory-stakeholders/organizations/organization-persons/organization-persons-edit/organization-persons-edit.component';
import { OrganizationsEditComponent } from 'src/app/routes/directory/directory-stakeholders/organizations/organizations-edit/organizations-edit.component';
import { ITabComponent, TabRole, TabsService } from 'src/app/libs/components/tabs-host/tabs.service';
import { ProductsEditComponent } from 'src/app/routes/products/operative/products-operative-products/products-edit/products-edit.component';
import { Organization, Person, Product } from 'src/app/models';
import { GenericCrudEditComponent } from 'src/app/libs/components/generic-crud/generic-crud-edit.component';

@Component({
    selector: 'app-global-search-result-item',
    templateUrl: './global-search-result-item.component.html',
    styleUrls: ['./global-search-result-item.component.sass'],
    standalone: false
})
export class GlobalSearchResultItemComponent {
  @Input() data: any;

  icons: {[key: number]: string} = {
    0: 'all_inclusive',
    3: 'corporate_fare',
    4: 'inventory_2',
    6: 'group',
  };

  

  // constructor(private tabs: TabsService) { }

  // async show(): Promise<void> {
  //   var entity;
  //   let tab: ITabComponent<GenericCrudEditComponent<any>>;
  //   let component: Type<GenericCrudEditComponent<any>>;
  //   let title: {text: string, params?: any} | undefined = undefined;
  //   switch (this.data.aggregateTypeId) {
  //     case 3:
  //       entity = this.data as Organization;
  //       component = OrganizationsEditComponent;
  //       break;
  //     case 4:
  //       entity = this.data as Product;
  //       component = ProductsEditComponent;
  //       break;
  //     case 6:
  //       entity = this.data as Person;
  //       component = OrganizationPersonsEditComponent;
  //       break;
  //   }
  //   tab = this.tabs.createTab(component!, TabRole.EDITION, {
  //     title,
  //     inputPrms: {
  //       entity: entity,
  //     }
  //   })
  //   // Close tab when entity is saved
  //   const editor = tab.component.instance;
  //   editor.entityChanged.pipe(takeUntil(editor.destroy$)).subscribe(() => tab?.close());
  // }
}
